export default __webpack_public_path__ + "static/media/support-notes-logo-mexico-bussiness.c8c37f6e.svg";